import React from 'react';
import PageWrapper from '../PageWrapper/PageWrapper';
import { useSearchHandlers } from '../../hooks/useSearchHandlers';
import { defaultSearchOptions } from '../../constants/realVenueData';

const SearchPageWrapper = ({ children, useNewFooter = false }) => {
  const {
    searchData,
    setSearchData,
    showLocationDropdown,
    setShowLocationDropdown,
    handleSearchSubmit,
    handleLocationSelect
  } = useSearchHandlers();

  return (
    <PageWrapper
      showSearchBar={true}
      searchData={searchData}
      setSearchData={setSearchData}
      handleSearchSubmit={handleSearchSubmit}
      handleLocationSelect={handleLocationSelect}
      showLocationDropdown={showLocationDropdown}
      setShowLocationDropdown={setShowLocationDropdown}
      defaultSearchOptions={defaultSearchOptions}
      useNewFooter={useNewFooter}
    >
      {children}
    </PageWrapper>
  );
};

export default SearchPageWrapper;